import React, { FC } from "react";
import SectionGridHasMap from "./SectionGridHasMap";
import { Helmet } from "react-helmet";
import { useLocale } from "i18n/locale";

export interface ListingStayMapPageProps {
  className?: string;
}

const ListingStayMapPage: FC<ListingStayMapPageProps> = ({
  className = "",
}) => {
  const { t } = useLocale();

  return (
    <div
      className={`nc-ListingStayMapPage relative bg-white ${className}`}
      style={{ marginBottom: 60 }}
      data-nc-id="ListingStayMapPage"
    >
      <Helmet>
        <title>Europea || Booking</title>
      </Helmet>

      {/* Page tagline */}
      <div className="px-4 sm:px-6 lg:px-[40px] mt-[14px]">
        <div className="flex flex-col">
          <p
            className="text-[11px] uppercase tracking-[2.2px] leading-[24px] text-[#B88333]"
            style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600 }}
          >
            {t("home.tagline")}
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-[4px] sm:gap-[16px]">
            <p
              className="flex-1 text-[18px] sm:text-[20px] tracking-[0.4px] text-[#01152E]"
              style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
            >
              {t("home.heading")}
            </p>
            <p
              className="text-[12px] uppercase tracking-[1.2px] text-[#01152E] whitespace-nowrap"
              style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
            >
              {t("common.brussels")} / {t("common.paris")}
            </p>
          </div>
        </div>
      </div>

      <SectionGridHasMap />
    </div>
  );
};

export default ListingStayMapPage;
